

import { email, required, minLength } from "vuelidate/lib/validators";
import "@/plugins/vuelidate"

export default {
  name: "RedSearchNow",
  props: ['maxh', 'empty', 'title', 'nopad', 'subtitle', 'button'],
  components: {},
  data() {
    return {
      info: '',
      formLogin: {
        name: "",
        email: "",
      },      
    }
  },

  validations: {
    formLogin: {
      name: { required, minLength: minLength(2) },
      email: { email, required },
    },
  },

  watch: {
    '$store.state.stepsUserModule.searchName': {
      immediate: true,
      handler(newName) {
        this.formLogin.name = newName;
      }
    },
    '$store.state.stepsUserModule.searchEmail': {
      immediate: true,
      handler(newEmail) {
        this.formLogin.email = newEmail;
      }
    },
  },

  computed: {

    name: {
      get() {
        return this.$store.state.stepsUserModule.searchName;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', value);
      }
    },
    email: {
      get() {
        return this.$store.state.stepsUserModule.searchEmail;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', value);
      }
    },

    isFormValid() {
      return !this.$v.formLogin.name.$invalid && !this.$v.formLogin.email.$invalid;
    }    
  },

  methods: {
    redirectUser() {
      this.name = this.formLogin.name;
      this.email = this.formLogin.email;

      if (!this.formLogin.name || !this.formLogin.email) {
        return;
      }      

      this.$router.push(`${this.$store.state.userModule.isLogged ? '/account/dashboard/' : '/auth/register?plan=1&product=FREE'}`)
    }
  },


  mounted() {
  },

  unmounted() {
  },
}
